export const CLASS_NAMES = {
  notRelevantButton: 'idea-not-relevant-button',
} as const;
